<template>
    <div  style="background:white; height:100vh">
        <el-tabs  @tab-click="tabClick"  :animated="false"  v-model="activeName" style="background:white; ">
            <el-tab-pane name='operate'>
                <span slot="label"><i class="iconfont icon-xiaoshouguanli"></i> 经营数据导入</span>               
            </el-tab-pane>
            <el-tab-pane name='return'>
                <span slot="label"><i class="iconfont icon-dengdaishouhuo"></i> 退货数据导入</span>           
            </el-tab-pane>
        </el-tabs>
        <span v-if="activeName=='operate'" >
            <manage-sum  ref="refsale" style="margin-top:-14px"></manage-sum>
        </span>
        <span v-else-if="activeName=='return'" >
            <div  ><return-sum  ref="refrtn" style="margin-top:-14px"></return-sum></div>
        </span>
    </div>
</template>
<script>
import manageSum from './manage_sum.vue'
import returnSum from './return_sum.vue'
export default {
    name:'amz_importData',
    data () {
        return {
            activeName:'operate'
        }
    },
    components: {
        manageSum,
        returnSum,
    },
    methods: {
        tabClick(){   
            if (this.activeName =='operate'){
                this.$refs['refsale'].getFocus()
            }else if (this.activeName =='return'){
                this.$refs['refrtn'].getFocus()
            }
        }
    }
}
</script>